const displayLinkControlTester = (uiSchema) => {
  return uiSchema.specializedType && uiSchema.specializedType === 'DisplayLink' ? 7 : 0
}

export default displayLinkControlTester